/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import BraftEditor from 'braft-editor';
import ReactMarkdown from 'react-markdown';
// 划线、表、任务列表和直接url等的语法扩展
import remarkGfm from 'remark-gfm';
// 解析标签，支持html语法
import rehypeRaw from 'rehype-raw'
// 代码高亮
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'
import { tomorrow } from 'react-syntax-highlighter/dist/esm/styles/prism'
// 内容样式
import 'github-markdown-css';
// import Editor from '@toast-ui/editor'
// import '@toast-ui/editor/dist/toastui-editor.css'
// import '@toast-ui/editor/dist/i18n/zh-cn';
import 'braft-editor/dist/index.css';
import 'braft-extensions/dist/code-highlighter.css';
import CodeHighlighter from 'braft-extensions/dist/code-highlighter';
import 'prismjs/components/prism-java';
import 'prismjs/components/prism-php';
import 'prismjs/components/prism-python';
import instance from '../../Communal/instance';
import Added from '../../../images/added.png';
import AuditStatus from '../../../images/audit-status.png';
import Denied from '../../../images/denied.png';
import Pass from '../../../images/pass.png';
import BuyCtf from '../../Activity/buyCtf';
import { Button } from 'antd';
import Reminder from '../../Communal/reminder';
import styled from 'styled-components';
import { useMappedState } from "redux-react-hook";

const Div = styled.div`
    width:100%!important;
    color:#333;
    .bf-content {
        height:auto
    }
    .bf-container .public-DraftEditor-content .braft-code-block-wrapper .braft-code-block{
        max-height:10000px
    }
`

const options = {
    syntaxs: [
        {
            name: 'JavaScript',
            syntax: 'javascript'
        }, {
            name: 'HTML',
            syntax: 'html'
        }, {
            name: 'CSS',
            syntax: 'css'
        }, {
            name: 'Java',
            syntax: 'java',
        }, {
            name: 'PHP',
            syntax: 'php'
        }, {
            name: "Python",
            syntax: 'python'
        }
    ],
}
BraftEditor.use(CodeHighlighter(options))
function CtfDetail(param) {
    const editorDom = useRef();
    const editorIns = useRef();
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(null));
    const [detail, setDetail] = useState({});
    const [buyCtf, setBuyCtf] = useState(false);
    const [reminderShow, setReminderShow] = useState(false);
    const [userType, setUserType] = useState(0);
    useEffect(() => {
        getDetail();
        instance.get("/ctf/user/type/?mode=tool").then(data => {
            setUserType(data.user_type)
        })
    }, []);
    // useEffect(() => {
    //     if (detail.tool_book_type === 2) {
    //         editorIns.current = new Editor({
    //             el: editorDom.current,
    //             language: 'zh-CN',
    //             height: 'auto',
    //             initialEditType: 'wysiwyg',
    //             placeholder: '请输入工具手册',
    //             initialValue: detail.tool_book_md,
    //             toolbarItems: [],
    //             hideModeSwitch: true
    //         });
    //     }
    // }, [detail.tool_book_type]);
    let getDetail = () => {
        instance.get("/tool/" + param.param.match.params.id + "/").then(data => {
            setDetail(data)
            setEditorState(BraftEditor.createEditorState(data.tool_book))
        })
    }
    // 拿到公共的值---实时变化
    const mapstate = useCallback((state) => ({
        userInfo: state.userInfo
    }), []);
    //获取数据并订阅存储
    const loginInfo = useMappedState(mapstate);
    return (
        <div className="activity-ctf-detail submit-ctf">
            <div className="banner"></div>
            <div className="content-container">
                <div className="submit-ctf-name submit-ctf-div">
                    {
                        param.param.match.params.where === "0" &&
                        <div style={{ display: "inline-block" }} className='ctf-name'>
                            <span onClick={() => window.location.href = "/#/resource"}>资源中心</span> ＞ <span onClick={() => window.location.href = "/#/resource/tool"}>安全工具资源库</span> ＞ {detail.name}
                        </div>
                    }
                    {
                        param.param.match.params.where === "1" &&
                        <div style={{ display: "inline-block" }} className='ctf-name'>
                            <span onClick={() => window.location.href = "/#/activity"}>活动中心</span> ＞ {detail.name}
                        </div>
                    }
                    {
                        param.param.match.params.where === "2" &&
                        <div style={{ display: "inline-block" }} className='ctf-name'>
                            <span onClick={() => window.location.href = "/#/personal/5"}>个人中心</span> ＞ {detail.name}
                        </div>
                    }
                    {
                        detail.is_show_opin &&
                        <div className="status">
                            {
                                detail.status === 0 &&
                                <img src={AuditStatus} alt="" />
                            }
                            {
                                detail.status === 1 &&
                                <img src={Pass} alt="" />
                            }
                            {
                                detail.status === 2 &&
                                <img src={Added} alt="" />
                            }
                            {
                                detail.status === 3 &&
                                <img src={Denied} alt="" />
                            }
                        </div>
                    }
                </div>
                {
                    detail.is_show_opin && detail.opin && detail.opin.length > 0 &&
                    <div className="submit-ctf-div audit-opinion">
                        <div className="title" style={{ borderBottom: "1px solid #f4f4f4" }}>审核意见</div>
                        <div className="content">
                            <div>
                                {
                                    detail.opin &&
                                    detail.opin.map((val, key) => {
                                        return <div key={key + "key"}>
                                            <div className="time">[{val.time}]</div>
                                            <div className="details">
                                                <pre style={{ whiteSpace: "pre-line" }}>{val.msg}</pre>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        </div>
                    </div>
                }
                <div className="submit-ctf-div">
                    <div className="award">
                        <div>
                            <span>{detail.coin}</span>
                            <span>奖励</span>
                        </div>
                        <p onClick={() => setReminderShow(true)}>赚取更多奖励＞</p>
                    </div>
                    <div className="title">工具信息</div>
                    <div className="content">
                        {
                            detail.status === 1 &&
                            <div>
                                <span>工具编号</span>
                                <div>{detail.number ? detail.number : "暂无编号"}</div>
                            </div>
                        }
                        <div>
                            <span>工具名称</span>
                            <div>{detail.name}</div>
                        </div>
                        <div>
                            <span>工具简介</span>
                            <div style={{ paddingTop: "9px", lineHeight: "25px" }}>
                                <pre style={{ whiteSpace: "pre-wrap" }}>{detail.desc}</pre>
                            </div>
                        </div>
                        <div>
                            <span>工具分类</span>
                            <div>{detail.classify_name}/{detail.sec_classify_name}</div>
                        </div>
                        <div>
                            <span>工具标签</span>
                            <div className="tag">
                                {
                                    detail.keyword_list &&
                                    detail.keyword_list.map((val, key) => {
                                        return <span key={"key" + key}>{val}</span>
                                    })
                                }

                            </div>
                        </div>
                        {
                            detail.status === 1 && [
                                <div key="2">
                                    <span>提交用户</span>
                                    <div>
                                        {detail.username}
                                    </div>
                                </div>,
                                <div key="3">
                                    <span>提交时间</span>
                                    <div>
                                        {detail.sub_time}
                                    </div>
                                </div>
                            ]
                        }
                    </div>
                    {
                        detail.is_buy &&
                        <div className="title">
                            工具附件
                        </div>
                    }
                    {
                        !detail.is_buy &&
                        <div className="title">
                            工具附件
                            {
                                !detail.is_buy &&
                                <span>购买后可查看</span>
                            }
                        </div>
                    }
                    {
                        detail.is_buy &&
                        <div className="content">
                            <div>
                                <span>工具附件</span>
                                <div>
                                    {detail.tool_file ? <a href={detail.tool_file} download>{detail.attached_name}</a> : "暂无附件"}
                                </div>
                            </div>
                        </div>
                    }
                    <div className="title">
                        使用手册
                        {
                            !detail.is_buy &&
                            <span>购买后可查看</span>
                        }
                        {
                            userType > 1 && detail.tool_book_type === 1 &&
                            <a
                                download
                                href={"/ctf/" + param.param.match.params.id + "/export/?type=4"}
                            >
                                导出
                            </a>
                        }
                    </div>
                    {
                        detail.is_buy &&
                        <div className="content">
                            {
                                detail.tool_book_type === 1 &&
                                <div>
                                    <Div className="container">
                                        <BraftEditor
                                            value={editorState}
                                            readOnly
                                            controls={[]}
                                        />
                                    </Div>
                                </div>
                            }
                            {
                                detail.tool_book_type === 2 &&
                                <ReactMarkdown
                                    className='markdown-body'
                                    children={detail.tool_book_md}
                                    remarkPlugins={[remarkGfm, { singleTilde: false }]}
                                    rehypePlugins={[rehypeRaw]}
                                    components={{
                                        code({ node, inline, className, children, ...props }) {
                                            const match = /language-(\w+)/.exec(className || '')
                                            return !inline && match ? (
                                                <SyntaxHighlighter
                                                    children={String(children).replace(/\n$/, '')}
                                                    style={tomorrow}
                                                    language={match[1]}
                                                    PreTag="div"
                                                    {...props}
                                                />
                                            ) : (
                                                <code className={className} {...props}>
                                                    {children}
                                                </code>
                                            )
                                        }
                                    }}
                                />
                            }
                        </div>
                    }
                </div>
                {
                    !detail.is_buy &&
                    <div className="buy-button">
                        <Button type="primary" onClick={() => setBuyCtf(true)}>购买</Button>
                    </div>
                }
            </div>
            {
                buyCtf &&
                <BuyCtf
                    coin={detail.coin}
                    url={"/tool/" + detail.id + "/buy/"}
                    close={() => setBuyCtf(false)}
                    getDetail={getDetail}
                />
            }
            {
                reminderShow &&
                <Reminder
                    close={() => setReminderShow(false)}
                />
            }
        </div>
    )
}
export default CtfDetail;